export const dataConstants = {
  DATA_GET_REQUEST: "DATA_GET_REQUEST",
  DATA_GET_SUCCESS: "DATA_GET_SUCCESS",
  DATA_GET_FAILURE: "DATA_GET_FAILURE",

  DATA_GET_ONE_REQUEST: "DATA_GET_ONE_REQUEST",
  DATA_GET_ONE_SUCCESS: "DATA_GET_ONE_SUCCESS",
  DATA_GET_ONE_FAILURE: "DATA_GET_ONE_FAILURE",

  DATA_SELECTED_COMPANY: "DATA_SELECTED_COMPANY",
};
